import { render, staticRenderFns } from "./ArmorUpgrades.vue?vue&type=template&id=54ce25a2&scoped=true&"
import script from "./ArmorUpgrades.vue?vue&type=script&lang=js&"
export * from "./ArmorUpgrades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ce25a2",
  null
  
)

export default component.exports